import InfoCircled from './InfoCircled'

export default InfoCircled
// eslint-disable-next-line import/export
export * from './InfoCircled'
